
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.69 44.163h.003c.321.123.6.32.841.598.217.251.317.52.317.826 0 .396-.14.716-.44.992-.302.277-.67.421-1.14.421H7.494c-2.403 0-4.128-.564-5.263-1.608C1.104 44.356.5 42.777.5 40.562V7.53c0-2.23.608-3.83 1.746-4.89C3.389 1.576 5.126 1 7.544 1h25.238c2.436 0 4.175.575 5.31 1.64 1.13 1.06 1.734 2.659 1.734 4.89v24.55c0 .681-.087 1.24-.247 1.687a3.505 3.505 0 01-.656 1.151 8.87 8.87 0 01-.973.95l-.007.006-.008.006c-1.04.941-1.715 1.976-1.97 3.109-.248 1.108-.14 2.15.344 3.102.489.96 1.297 1.649 2.382 2.072zM10.35 3.99h-.5v29.743h.5l23.735-.001c.715 0 1.344-.157 1.798-.558.465-.411.657-1 .657-1.671V7.715c0-1.142-.327-2.09-1.048-2.763-.722-.673-1.766-.964-3.036-.964l-22.105.002zM3.81 34.062v.833l.736-.392a6.234 6.234 0 011.567-.576 7.58 7.58 0 01.895-.145l.12-.009.463-.034V3.983l-.547.052-.07.007h-.01l-.01.002c-.843.114-1.555.405-2.095.908-.721.673-1.048 1.621-1.048 2.763v26.347zm29.373 10.112h.934l-.518-.778a5.813 5.813 0 01-.97-2.955c-.06-1.087.176-2.159.723-3.223l.428-.833-.93.107-.392.047.029.234-.029-.234c-.102.012-.219.02-.353.02H8.12c-1.301 0-2.391.324-3.209 1.032-.817.706-1.226 1.634-1.226 2.74 0 1.151.35 2.113 1.097 2.819.754.712 1.84 1.024 3.163 1.024h25.238z","fill":"#fff","stroke":"#fff"}})])
          )
        }
      }
    